<!-- In use for "Zertifikate" & "Anbieter"  -->
<mat-card class="display-card" appearance="outlined"
    [class]="{ 'mat-elevation-z8 hover': hover || focus , 'prioritized': isPrioritized, 'provider-card': isProvider }"
    (mouseenter)="hover = true" (mouseleave)="hover = false" *ngIf="!isProduct">
    <!-- <div *ngIf="isPrioritized" class="prioritized-container"><img src="/assets/img/icons/prio_product_icon.png"
            alt=""><span>Gesponsert</span>
    </div> -->
    <div [class]="{ 'provider-card-image-cell': isProvider }">
        <div [class]="{ 'provider-image': isProvider }">
            <app-secure-image *ngIf="itemInfo.fileId != null" [displayItem]="true" [fileId]="itemInfo.fileId"
                [src]="itemInfo.pictureUrl">
            </app-secure-image>
        </div>
        <button mat-mini-fab color="accent" *ngIf="isLoggedIn()"
            (click)="toggleProductInList(itemInfo.id); bookmark($event)" class="bookmark-btn bookmark-icon2">
            <mat-icon color="accent">{{
                bookmarked ? 'bookmark' : 'bookmark_border'
                }}</mat-icon>
        </button>
    </div>
    <div class="card-header">
        <div mat-card-avatar class="avatar" *ngIf="!isProvider">
            <app-image-slider [organisation]="this.organisation" *ngIf="
                        this.organisation != null &&
                            this.organisation.fileId != null;
                        else blankOrganisationLogo
                    ">
            </app-image-slider>
            <ng-template #blankOrganisationLogo>
                <div style="width: 40px; height: 40px; margin-right: 5px"></div>
            </ng-template>
        </div>
        <div class="header-text-container">
            <mat-card-title class="cut-text" id="displayTitle" *ngIf="!isSharePoint" [class]="{
                        productOrCertifiName:
                            !isProvider && itemInfo.name.length > 45,
                    }" style="hyphens: auto">
                <ng-container>
                    {{ itemInfo.name }}
                </ng-container>
            </mat-card-title>
            <mat-card-title class="cut-text" id="displayTitle" *ngIf="!isSharePoint" [class]="{
                    productOrCertifiName:
                        !isProvider && itemInfo.name.length > 45,
                    'provider-name': isProvider
                }" style="hyphens: auto">
                <ng-container>
                    {{ itemInfo.properties?.dataName}}
                </ng-container>
            </mat-card-title>
            <mat-card-subtitle class="cut-text" id="subscr" *ngIf="!isProvider">
                {{ itemInfo.subscript }}
            </mat-card-subtitle>
        </div>
        <div *ngIf="isCertification" class="certificate-icon2-item">
            <app-certificate-mini-display [certificateType]="itemInfo.certificationType"
                [certCount]="itemInfo.productsCertified">
            </app-certificate-mini-display>
        </div>
    </div>
    <div style="contain: content">
        <div class="rating-certification-grid" *ngIf="isProduct">
            <div #colmn1 *ngIf="itemInfo.reviewRating" class="certificate-icon-item">
                <app-star [rating]="itemInfo.reviewRating.rating"
                    [ratingCount]="itemInfo.reviewRating.reviewNumber"></app-star>
            </div>
            <div #colmn2 class="certificate-icon-item certificate-iconFull" *ngIf="itemInfo.displayType === 'PRODUCT'"
                class="certificate-iconFull">
                <app-certificate-mini-display *ngIf="
                    ( itemInfo?.ptgCertificationCount &&
                    itemInfo?.ptgCertificationCount > 0 ) ||
                    (itemInfo?.attributeCertificationCount &&
                    itemInfo?.attributeCertificationCount > 0 ) ||
                    (itemInfo?.ptgsWhereAllMandatoryAttributesImplementedCount &&
                    itemInfo?.ptgsWhereAllMandatoryAttributesImplementedCount > 0)
                " [certificateType]="'BIMSWARM_CERT'" [full]="true"
                    [certCount]="totalCertificateCount"></app-certificate-mini-display>
                <div class="certificate-containerFull" *ngIf="enterprise">
                    <div matTooltip="{{ certificationTooltip }}" [matTooltipPosition]="'above'" class="cert-imageFull"
                        [ngStyle]="{ 'background-image': 'url(' + certificationImageUrl + ')' }"></div>
                    <p style="margin: auto" matTooltip="{{ certificationCountTooltip }}" [matTooltipPosition]="'below'">
                        Partner
                    </p>
                </div>

            </div>
            <!-- <div
                #colmn2
                class="certificate-icon-item"
                *ngIf="itemInfo.displayType === 'PRODUCT'"
            >
                <app-certificate-mini-display
                    *ngIf="
                        itemInfo.attributeCertificationCount &&
                        itemInfo.attributeCertificationCount > 0
                    "
                    [certificateType]="'ATTRIBUTE_CERT'"
                    [certCount]="itemInfo.attributeCertificationCount"
                >
                </app-certificate-mini-display>
                <app-certificate-mini-display
                    *ngIf="
                        itemInfo.ptgCertificationCount &&
                        itemInfo.ptgCertificationCount > 0
                    "
                    [certificateType]="'PTG_CERT'"
                    [certCount]="itemInfo.ptgCertificationCount"
                ></app-certificate-mini-display>
                <app-certificate-mini-display
                    *ngIf="
                        itemInfo.toolchainCertificationCount &&
                        itemInfo.toolchainCertificationCount > 0
                    "
                    [certificateType]="'TOOLCHAIN_CERT'"
                    [certCount]="itemInfo.toolchainCertificationCount"
                >
                </app-certificate-mini-display>
                <app-certificate-mini-display
                    *ngIf="
                        itemInfo.ptgsWhereAllMandatoryAttributesImplementedCount >
                        0
                    "
                    [certificateType]="'ATTRIBUTE_MANDATORY_CERT'"
                    [certCount]="
                        itemInfo.ptgsWhereAllMandatoryAttributesImplementedCount
                    "
                >
                </app-certificate-mini-display>
            </div>-->
        </div>
        <div class="description" *ngIf="isSharePoint">
            <p class="wordwrap4">{{ this.removeEntersAssets().substring(0, 400).trim() }}</p>
        </div>
        <div class="description" *ngIf="isProduct">
            <p class="wordwrap4">{{ this.removeEnters().substring(0, 400).trim() }}</p>
        </div>
        <div class="description" *ngIf="isProvider || isCertification">
            <p class="wordwrap2">{{ this.removeEnters().substring(0, 400).trim() }}</p>
        </div>
        <div class="org-cert-icons" *ngIf="isProvider && certificates.length > 0">
            <span *ngFor="let certificate of certificates" [matTooltip]="getCertificateTooltip(certificate)"
                matTooltipClass="tooltip header-tooltip" [matTooltipPosition]="'above'"
                (click)="openCertificateDetail(certificate, $event)" class="org-cert-icon-clickable">
                <img [src]="certificate.getIcon()" alt="Certificate Icon">
            </span>
        </div>
    </div>
</mat-card>


<!-- In use for "Produkte" -->
<mat-card class="display-card2" appearance="outlined"
    [class]="{ 'mat-elevation-z8 hover': hover || focus , 'prioritized': isPrioritized }" (mouseenter)="hover = true"
    (mouseleave)="hover = false" *ngIf="isProduct">
    <!-- <div *ngIf="isPrioritized" class="prioritized-icon"><span>Gesponsert</span></div> -->
    <!-- <div *ngIf="isPrioritized" class="prioritized-container"><img src="/assets/svg-icons/prio_product_icon.svg" alt=""><span>Gesponsert</span></div> -->
    <div *ngIf="isPrioritized" class="prioritized-container">
        <mat-icon svgIcon="prio-product"></mat-icon>
        <span>Gesponsert</span>
    </div>
    <!-- <div *ngIf="isPrioritized" class="prioritized-chip-container"><span>Gesponsert</span></div> -->

    <!-- first section | head part -->
    <div class="headerContainer2 card-header">
        <div style="position: relative; height: 100%;">
            <app-secure-image *ngIf="itemInfo.fileId != null" [displayItem]="true" [fileId]="itemInfo.fileId"
                [src]="itemInfo.pictureUrl" [isProduct]="true" class="mg-left">
            </app-secure-image>

            <div class="sharepoint-badge-on-card" *ngIf="isSharePoint">
                <img src="assets/img/sharepoint-logo.png" alt="SharePoint">
                <div class="card-combo-divider"></div>
                <mat-icon class="card-content-type-icon">
                    {{ getContentTypeIcon() }}
                </mat-icon>
            </div>
        </div>
        <!-- <button
            mat-mini-fab
            color="primary"
            *ngIf="isLoggedIn()"
            (click)="toggleProductInList(itemInfo.id); bookmark($event)"
            class="bookmark-icon2"
        >
            <mat-icon color="accent">{{
                bookmarked ? 'bookmark' : 'bookmark_border'
            }}</mat-icon>
        </button> -->

        <div class="header-text-container" [ngStyle]="{ 'margin-top': isPrioritized ? '24px' : '0' }">
            <!-- <mat-card-header class="mat-card-header-product"> -->
            <!-- <div mat-card-avatar class="avatar" *ngIf="!isProvider">
                    <ng-template #blankOrganisationLogo>
                        <div
                            style="width: 40px; height: 40px; margin-right: 5px"
                        ></div>
                    </ng-template>
                </div> -->
            <mat-card-title class="cut-text cut-text2" id="displayTitle" *ngIf="!isSharePoint" [class]="{
                    productOrCertifiName:
                        !isProvider && itemInfo.name.length > 45,
                    'provider-name': isProvider
                }" style="hyphens: auto">
                <ng-container>
                    {{ itemInfo.name }}
                </ng-container>
            </mat-card-title>
            <mat-card-title class="cut-text" id="displayTitle" *ngIf="isSharePoint" style="hyphens: auto">
                <ng-container>
                    {{ itemInfo.properties.dataName}}
                </ng-container>
            </mat-card-title>
            <mat-card-subtitle class="cut-text cut-text2" id="subscr" *ngIf="!isProvider">
                {{ itemInfo.subscript }}
            </mat-card-subtitle>
            <div *ngIf="isCertification" class="certificate-icon2-item">
                <mat-card-content>
                    <app-certificate-mini-display [certificateType]="itemInfo.certificationType"
                        [certCount]="itemInfo.productsCertified">
                    </app-certificate-mini-display>
                </mat-card-content>
            </div>
            <!-- </mat-card-header> -->
        </div>
    </div>

    <!-- second section | rating part -->
    <div *ngIf="isProduct">
        <div #colmn1 *ngIf="itemInfo.reviewRating">
            <app-star [rating]="itemInfo.reviewRating.rating" [ratingCount]="itemInfo.reviewRating.reviewNumber"
                [color]="true"></app-star>
        </div>
    </div>

    <!-- third section | Description -->
    <mat-card-content class="cardContentDesign">

        <div class="description2" *ngIf="isSharePoint">
            <p>{{ this.removeEntersAssets() }}</p>
        </div>
        <div class="description2" *ngIf="isProduct && !isSharePoint">
            <p>{{ this.removeEnters() }}</p>
        </div>
    </mat-card-content>

    <!-- forth section | ptg & certificates -->
    <div>
        <div class="bodyHeader">
            <div class="icon-container">
                @if (itemInfo.topOnePtgName) {
                <div>
                    <button class="btn-chip">
                        {{ itemInfo.topOnePtgName }}
                    </button>
                </div>
                }
                <div #colmn2 *ngIf="itemInfo.displayType === 'PRODUCT'" class="certificate-icon-simple">
                    <app-certificate-simple-display *ngIf="
                        ( itemInfo?.ptgCertificationCount &&
                        itemInfo?.ptgCertificationCount > 0 ) ||
                        (itemInfo?.attributeCertificationCount &&
                        itemInfo?.attributeCertificationCount > 0 )" [certificateType]="'BIMSWARM_CERT'" [full]="true"
                        [certCount]="totalCertificateCount"
                        class="certificate-icon-container"></app-certificate-simple-display>
                    <!-- <app-certificate-mini-display
                        *ngIf="
                        ( itemInfo?.ptgCertificationCount &&
                        itemInfo?.ptgCertificationCount > 0 ) ||
                        (itemInfo?.attributeCertificationCount &&
                        itemInfo?.attributeCertificationCount > 0 ) ||
                        (itemInfo?.ptgsWhereAllMandatoryAttributesImplementedCount &&
                        itemInfo?.ptgsWhereAllMandatoryAttributesImplementedCount > 0)
                        "
                        [certificateType]="'BIMSWARM_CERT'"
                        [full]="true"
                        [certCount]="totalCertificateCount"
                    ></app-certificate-mini-display> -->
                    <div class="certificate-icon-container" *ngIf="enterprise" matTooltip="{{ certificationTooltip }}"
                        [matTooltipPosition]="'above'"
                        [ngStyle]="{ 'background-image': 'url(' + certificationImageUrl + ')' }"
                        class="cert-imageFull partner-icon">
                        <div class="certificate-icon-container partner-icon" *ngIf="enterprise"
                            matTooltip="{{ certificationTooltip }}" [matTooltipPosition]="'above'">
                            <mat-icon svgIcon="partnershipCert" class="partner-icon__svg"></mat-icon>
                        </div>
                        <!-- <mat-icon color="accent" class="partner-icon">handshake</mat-icon> -->
                    </div>
                </div>

                <button mat-mini-fab color="accent" *ngIf="isLoggedIn()"
                    (click)="toggleProductInList(itemInfo.id); bookmark($event)" class="bookmark-icon2">
                    <mat-icon color="accent">{{
                        bookmarked ? 'bookmark' : 'bookmark_border'
                        }}</mat-icon>
                </button>
                <!--            <div
        #colmn2
        class="certificate-icon-item mg-bot-0"
        *ngIf="itemInfo.displayType === 'PRODUCT'">
        <app-certificate-mini-display
            *ngIf="
                itemInfo.attributeCertificationCount &&
                itemInfo.attributeCertificationCount > 0
            "
            [certificateType]="'ATTRIBUTE_CERT'"
            [full]="true"
            [certCount]="itemInfo.attributeCertificationCount"
        >
        </app-certificate-mini-display>
        <app-certificate-mini-display
            *ngIf="
                itemInfo.ptgCertificationCount &&
                itemInfo.ptgCertificationCount > 0
            "
            [certificateType]="'PTG_CERT'"
            [certCount]="itemInfo.ptgCertificationCount"
            [full]="true"
        ></app-certificate-mini-display>
        <app-certificate-mini-display
            *ngIf="
                itemInfo.toolchainCertificationCount &&
                itemInfo.toolchainCertificationCount > 0
            "
            [certificateType]="'TOOLCHAIN_CERT'"
            [certCount]="itemInfo.toolchainCertificationCount"
            [full]="true"
        >
        </app-certificate-mini-display>
        <app-certificate-mini-display
            *ngIf="
                itemInfo.ptgsWhereAllMandatoryAttributesImplementedCount >
                0
            "
            [certificateType]="'ATTRIBUTE_MANDATORY_CERT'"
            [certCount]="itemInfo.ptgsWhereAllMandatoryAttributesImplementedCount
            "
            [full]="true"
        >
        </app-certificate-mini-display>

        <div class="certificate-containerFull" *ngIf="isPrioritized">
            <div
                matTooltip="{{ certificationTooltip }}"
                [matTooltipPosition]="'above'"
                class="cert-imageFull"
                [ngStyle]="{ 'background-image': 'url(' + certificationImageUrl + ')' }"
            ></div>
            <p
                style="margin: auto"
                [matTooltipPosition]="'below'"
            >
                 Partner
            </p>
        </div>
    </div> -->
            </div>
        </div>

    </div>
</mat-card>